var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _circle4, _circle5, _circle6, _rect5, _rect6, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLookAtKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 197,
    viewBox: "0 0 187 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.759 104.418C166.759 139.212 136.538 167.418 99.2588 167.418C61.9796 167.418 31.7588 139.212 31.7588 104.418C31.7588 69.624 61.9796 41.418 99.2588 41.418C136.538 41.418 166.759 69.624 166.759 104.418Z",
    fill: "url(#paint0_linear_1638_884)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7588 27.418H103.759V43.418H93.7588V27.418Z",
    fill: "url(#paint1_linear_1638_884)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.7588,
    cy: 15.418,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7588 172.418C139.523 172.418 171.759 142.421 171.759 105.418C171.759 83.0449 159.974 63.2332 141.867 51.0645C140.185 49.9345 138.187 49.3916 136.161 49.3916H63.3566C61.3308 49.3916 59.3322 49.9345 57.6508 51.0645C39.5431 63.2332 27.7588 83.0449 27.7588 105.418C27.7588 142.421 59.9943 172.418 99.7588 172.418Z",
    fill: "url(#paint2_linear_1638_884)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5209,
    cy: 148.39,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 48.5209 148.39)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.618 158.264C62.3312 155.51 60.0658 148.879 54.5579 143.452C49.0501 138.026 42.3856 135.859 39.6723 138.613C36.959 141.367 39.2245 147.999 44.7323 153.425C50.2402 158.852 56.9047 161.018 59.618 158.264ZM54.8861 154.734C56.6126 152.981 55.1711 148.762 51.6665 145.309C48.1619 141.856 43.9213 140.477 42.1949 142.23C40.4685 143.982 41.91 148.202 45.4146 151.654C48.9191 155.107 53.1597 156.486 54.8861 154.734Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.716 150.72L55.8088 146.791L47.9514 140.605L44.8586 144.534L52.716 150.72ZM36 155.918L36.9806 160.821L36 155.918ZM25.4224 145.294C24.1339 142.852 21.1095 141.916 18.6671 143.205C16.2247 144.493 15.2892 147.517 16.5776 149.96L25.4224 145.294ZM44.8586 144.534C42.1125 148.022 40.098 149.408 38.8262 150.029C37.4705 150.69 36.7997 150.659 35.0194 151.015L36.9806 160.821C37.7003 160.677 40.3398 160.417 43.2111 159.016C46.1664 157.574 49.2955 155.065 52.716 150.72L44.8586 144.534ZM35.0194 151.015C35.2702 150.965 34.9334 151.071 33.7692 150.71C32.7477 150.393 31.5104 149.848 30.2383 149.131C28.9727 148.418 27.7967 147.605 26.8773 146.823C26.4203 146.435 26.063 146.084 25.8025 145.79C25.6741 145.645 25.5803 145.526 25.5148 145.435C25.4826 145.39 25.4595 145.355 25.444 145.33C25.4283 145.305 25.422 145.293 25.4224 145.294L16.5776 149.96C17.5094 151.726 19.0034 153.254 20.3982 154.44C21.868 155.691 23.5839 156.86 25.3296 157.844C27.0689 158.824 28.9622 159.689 30.8073 160.261C32.5096 160.789 34.7751 161.262 36.9806 160.821L35.0194 151.015Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6782 150.767L55.818 146.875L48.0357 140.596L44.8958 144.487L52.6782 150.767ZM39 155.418L37.2913 150.719L39 155.418ZM26.1154 143.495C25.0533 140.946 22.1259 139.74 19.5769 140.803C17.0279 141.865 15.8225 144.792 16.8846 147.341L26.1154 143.495ZM16.8846 147.341C17.1383 147.95 17.4307 148.537 17.7508 149.1L26.4427 144.155C26.306 143.915 26.1983 143.694 26.1154 143.495L16.8846 147.341ZM38.3792 160.69C39.1516 160.583 39.9345 160.398 40.7087 160.117L37.2913 150.719C37.2357 150.739 37.1433 150.766 37.0043 150.785L38.3792 160.69ZM40.7087 160.117C40.9542 160.028 41.1824 159.947 41.3951 159.874L38.1415 150.418C37.8754 150.51 37.5926 150.609 37.2913 150.719L40.7087 160.117ZM52.1775 151.389C52.3379 151.189 52.5047 150.982 52.6782 150.767L44.8958 144.487C44.7163 144.709 44.5438 144.924 44.3779 145.13L52.1775 151.389Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2076 149.627C58.1456 147.573 56.5676 145.432 54.5579 143.452C51.4413 140.382 47.9543 138.355 45.0224 137.673L46.2595 141.816C47.9746 142.373 49.9127 143.581 51.6665 145.309C53.0727 146.694 54.1468 148.203 54.8173 149.627H59.2076Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5557,
    cy: 138.973,
    r: 10.625,
    transform: "rotate(-30.6263 17.5557 138.973)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 160.765 145.112)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.906 158.264C136.193 155.51 138.459 148.879 143.966 143.452C149.474 138.026 156.139 135.859 158.852 138.613C161.565 141.367 159.3 147.999 153.792 153.425C148.284 158.852 141.62 161.018 138.906 158.264ZM143.638 154.734C141.912 152.981 143.353 148.762 146.858 145.309C150.363 141.856 154.603 140.477 156.33 142.23C158.056 143.982 156.614 148.202 153.11 151.654C149.605 155.107 145.365 156.486 143.638 154.734Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 150.72L142.715 146.791L150.572 140.605L153.665 144.534L145.808 150.72ZM164.5 163.127L168.974 160.893L164.5 163.127ZM158.857 177.769C156.293 178.795 153.383 177.548 152.358 174.984C151.332 172.42 152.579 169.51 155.143 168.485L158.857 177.769ZM153.665 144.534C156.386 147.991 158.939 150.058 161.53 152.241C164.086 154.396 166.972 156.884 168.974 160.893L160.027 165.361C159.033 163.369 157.62 162.024 155.085 159.887C152.584 157.779 149.253 155.097 145.808 150.72L153.665 144.534ZM168.974 160.893C170.265 163.48 170.731 166.222 169.957 168.893C169.209 171.474 167.519 173.236 165.999 174.377C163.294 176.406 159.289 177.596 158.857 177.769L155.143 168.485C155.579 168.31 156.123 168.122 156.519 167.982C156.972 167.823 157.415 167.663 157.861 167.485C158.79 167.113 159.511 166.743 159.998 166.377C160.478 166.017 160.412 165.904 160.352 166.111C160.266 166.407 160.483 166.274 160.027 165.361L168.974 160.893Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 150.72L142.715 146.791L150.572 140.605L153.665 144.534L145.808 150.72ZM163.5 161.418L167.973 159.184L163.5 161.418ZM158.506 177.895C155.873 178.726 153.064 177.266 152.232 174.633C151.401 171.999 152.861 169.191 155.495 168.359L158.506 177.895ZM155.495 168.359C155.812 168.259 156.113 168.16 156.4 168.063L159.606 177.535C159.25 177.656 158.883 177.776 158.506 177.895L155.495 168.359ZM159.434 164.491C159.311 164.228 159.176 163.95 159.027 163.653L167.973 159.184C168.15 159.538 168.322 159.891 168.487 160.242L159.434 164.491ZM159.027 163.653C158.895 163.388 158.763 163.15 158.632 162.932L167.186 157.754C167.462 158.209 167.724 158.685 167.973 159.184L159.027 163.653ZM146.683 151.797C146.393 151.451 146.101 151.093 145.808 150.72L153.665 144.534C153.895 144.826 154.121 145.104 154.343 145.368L146.683 151.797Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.317 149.627C140.379 147.573 141.957 145.432 143.966 143.452C147.083 140.382 150.57 138.355 153.502 137.673L152.265 141.816C150.55 142.373 148.612 143.581 146.858 145.309C145.452 146.694 144.378 148.203 143.707 149.627H139.317Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.556,
    cy: 176.973,
    r: 10.625,
    transform: "rotate(-30.6263 152.556 176.973)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 147.418,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 147.418,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 144.418,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 67.418,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 105.918,
    r: 8.5,
    fill: "#72B2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 105.918,
    r: 8.5,
    fill: "#72B2FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 131.418,
    r: 8,
    stroke: "#54D052",
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 79.418,
    width: 6,
    height: 45,
    fill: "#54D052"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 79.418,
    width: 10,
    height: 3,
    fill: "#54D052"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 84.418,
    width: 8,
    height: 3,
    fill: "#54D052"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 89.418,
    width: 10,
    height: 3,
    fill: "#54D052"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1638_884",
    x1: 99.2588,
    y1: 27.418,
    x2: 99.2588,
    y2: 167.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1638_884",
    x1: 99.2588,
    y1: 27.418,
    x2: 99.2588,
    y2: 167.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1638_884",
    x1: 99.7588,
    y1: 38.4178,
    x2: 99.7588,
    y2: 172.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookAtKey);
export default __webpack_public_path__ + "static/media/look_at_key.8fee59fe64ffce0e464f30831c7c1042.svg";
export { ForwardRef as ReactComponent };